"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObject = void 0;
var IkeObject = /** @class */ (function () {
    function IkeObject() {
    }
    /**
     * Copy Keys from src into dest omitting any null or undefined values
     *
     * @param dest the destination object to copy into
     * @param src the source object to copy from
     * @returns nothing as the destination object is updated.
     */
    IkeObject.assignNotNull = function (dest, src) {
        for (var _i = 0, _a = Object.keys(src); _i < _a.length; _i++) {
            var key = _a[_i];
            var value = src[key];
            if (value == null) {
                continue;
            }
            dest[key] = value;
        }
    };
    return IkeObject;
}());
exports.IkeObject = IkeObject;
//# sourceMappingURL=object.js.map